// The one place a product turns into a URL.
//
// Products carry two names. `id` is the internal one -- what the cart, orders,
// reviews, wishlists and the stock filters all store, and what every API call
// about a product should keep using. `publicId` is the one that belongs in an
// address bar: a readable slug with an unguessable suffix, e.g.
// `boat-headphones-k3f9q2m8`.
//
// They are deliberately NOT the same value. Swapping the internal id for the
// public one everywhere would have been a smaller diff, but it would have put
// a public id into the atomic stock-decrement filters in productsRepo, which
// match on `_id` directly -- a checkout that silently fails to decrement is a
// far worse bug than an ugly URL.
//
// The fallback matters: a product fetched from a backend that has not run
// scripts/backfill-public-ids.js yet has no publicId, and the internal id
// still resolves (the server accepts either), so a stale deployment degrades
// to the old links rather than to "/product/undefined".

// The id a product should be ADDRESSED by. Use this wherever a component
// hands an id up to a navigate() it does not own -- onProductClick(id) and
// friends -- so the callback keeps working untouched.
export const productLinkId = (product) => {
  const p = product || {};
  return p.publicId || p.id;
};

// The full path, for a <Link to=...> or a navigate().
export const productPath = (product) => {
  const id = productLinkId(product);
  return id ? `/product/${encodeURIComponent(id)}` : '/';
};

export default productPath;
